Vue.filter('importo', function (value) {
  if (!$.isNumeric(value)) return '';
  return parseFloat(value).number_format(2,',','.');
})

Vue.filter('number', function (value) {
  if (!$.isNumeric(value)) return '';
  return parseFloat(value).number_format(0,',','.');
})

Vue.filter('currency', function (value, locale, currency) {
    if (!value) return '';
    if (!locale) locale = 'it-IT';
    if (!currency) currency = 'EUR';
    return parseFloat(value).toLocaleString(locale, { style: 'currency', currency: currency });
});

Vue.filter('toDate', function (value,currentFormat) {
    if (value instanceof Date || !value) return value;
    if (typeof currentFormat === 'undefined' || !currentFormat) currentFormat = 'YYYY-MM-DD HH:mm:ss';
    return moment(value,currentFormat).toDate();
})

Vue.filter('dateToString', function (date,format) {
    if (!(date instanceof Date)) return date;
    if (typeof format === 'undefined' || !format) format = 'YYYY-MM-DD';
    return moment(date).format(format);
})

Vue.filter('mydate', function (value,param,currentFormat) {
    // if (typeof currentFormat === 'undefined' || !currentFormat) currentFormat = 'YYYY-MM-DD HH:mm:ss';
    if (!value) return ''
  return moment(value, currentFormat).format(param);
})

Vue.filter('profiloLabel', function (value) {
    if (!value) return ''
    let arr = value.split('_');
    if (typeof arr[1] !== 'undefined') {
        arr[1] = '<small>/FLAT</small>';
    }
    return arr.join('');
})

Vue.filter('onlyPrefisso', function (value) {
    if (!value) return ''
    return value.split(" ")[0];
});

Vue.filter('mytime', function (value,param,currentFormat) {
    if (typeof currentFormat === 'undefined' || !currentFormat) currentFormat = 'HH:mm:ss';
    if (!value) return ''
  return moment(value,currentFormat).format(param);
})

Vue.filter('ucfirst', function (value,param) {
  if (!value) return ''
  return value.charAt(0).toUpperCase() + value.slice(1);
})

Vue.filter('getAge', function (date) {
  if (!date) return null;

  moment.locale('it');
  return moment().diff(moment(date), 'years');

});
Vue.filter('hr_size', function (size) {
  var label = 'B';
  if(size >= 1024) {
    size = size / 1024;
    label = "KB";
  }
  if(size >= 1024) {
    size = size / 1024;
    label = "MB";
  }
  if(size >= 1024) {
    size = size / 1024;
    label = "GB";
  }
  return Math.round(size) + " " + label;
});
Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
});

Vue.filter('templatestato', function (value) {
    if (!value) return ''
    let tmp = `<span data-toggle="tooltip" data-placement="left" title="${Idoc.legendStatiPren[value]}" class="badge badge-:typebadge">${(value).replace('_',' ')}</span>`;
    let type = 'warning';
    if (['eseguita','confermata'].indexOf(value) >= 0) type = 'success';
    if (['disdetta','annullata'].indexOf(value) >= 0) type = 'secondary';
    if (['annullata_medico'].indexOf(value) >= 0) type = 'danger';
    return tmp.replace(':typebadge',type);
});

Vue.filter('profiloTab', function (value,param) {
    if (!value) return ''
    return value.replace('_flat','');
})

Vue.filter('suggestionLabel', function (value) {
    let label = value;
    if (typeof value == 'object') {
        label = value.label;
    }
    return label;
})

Vue.directive('click-outside', {
    bind(el, binding, vnode) {
        var vm = vnode.context;
        var callback = binding.value;

        el.clickOutsideEvent = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
                return callback.call(vm, event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
});

Vue.directive('collapsible', {
    bind: function (el, binding) {
       el.transitionDuration = 350;
    },
    update: function (el, binding) {
        if ($(el).hasClass('not-collapsed')) return;
       if (binding.oldValue != binding.value){
           if (binding.value) {
              setTimeout(function () {
                  el.classList.remove("collapse");
                  var height = window.getComputedStyle(el).height;
                  el.classList.add('collapsing');
                  el.offsetHeight;
                  el.style.height = height;
                  setTimeout(function() {
                     el.classList.remove("collapsing");
                     el.classList.add('collapse');
                     el.style.height = null;
                     el.classList.add('show');
                 }, el.transitionDuration)
              }, 0);
           }
           else {
              el.style.height = window.getComputedStyle(el).height;
              el.classList.remove("collapse");
              el.classList.remove('show');
              el.offsetHeight;
              el.style.height = null;
              el.classList.add('collapsing');
              setTimeout(function() {
                 el.classList.add('collapse');
                 el.classList.remove("collapsing");
              }, el.transitionDuration)
           }
       }
    }
});

Vue.directive('show-if-not-in-viewport', {
    bind: function (el, binding) {
        setTimeout(() => {
            if ($(el).isInViewport()) {
                el.style.display = 'none';
            }
        }, 1);


     },
     update: function (el, binding) {
        el.style.display = null;
        setTimeout(() => {
            if ($(el).isInViewport()) {
                el.style.display = 'none';
            }
        }, 1);

     }
});

Vue.directive('usertaggable', {
    inserted: function (el, binding) {
        el.classList.add('usertaggable');
        userTags.initializeInputs();

        userTags.setCallback((value) => {
            el.value = value;
            el.dispatchEvent(new Event('input'), { bubbles: true });
        });
    },
    update: function (el, binding) {
        if (! el.value) {
            dataTargetId = el.getAttribute('data-target-id');
            userTags.updateInputByTargetId(dataTargetId);
        }
    }
});
